export default {

  productList: [],
  preSelectedProduct: null,
  selectedProduct: null,
  cartEntry: {},
  carts: [{
    id: Date.now(),
    cartEntries: [],
    totalPrice: 0,
    active: true,
    isNavigatedByQuestion: false
  }],
  screenLock : true,
  isLoading:false,
  activePersonal : null,
  personList:[],
  toUpdateEntry : null,
  isReset : false,
  lastBillId : 0,
  paymentMethods : [{}],
  selectedPaymentMethod : null,
  isLossModeOn : false,
  lossTypeSelection: true,
  selectedLossStocks:[],
  isCakeQuestioned : false,
  navigationQuestion: {},
  hasNeedNavigationByQuestion: false,
  currentTab:null,
  areas:[],
  isTableMove: false,
  isTableMerge: false,
  printerSettings: {},
  selectedPosId: null,
  kuverSettings: {
    isEnable: false,
    unitPrice: 0
  },
  discountReasons: [],
  isActiveTablesFilter: false,
};
